var _rect, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 22.0068,
    y: 15.6421,
    width: 15.1206,
    height: 15.1206,
    transform: "rotate(45 22.0068 15.6421)",
    fill: "#E10512"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.5528 24.2852L36.0984 22.7396C39.0007 19.8373 39.0007 15.1317 36.0984 12.2294C33.1961 9.32708 28.4905 9.32707 25.5882 12.2294L24.0426 13.775L34.5528 24.2852Z",
    fill: "#00BB86"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.45697 24.31L7.90913 22.7622C5.00265 19.8557 5.00265 15.1433 7.90913 12.2369C10.8156 9.33039 15.5279 9.33038 18.4344 12.2369L19.9823 13.7847L9.45697 24.31Z",
    fill: "#0062CE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/2.518c44fd04986d92e950b07e55e3594d.svg";
export { ForwardRef as ReactComponent };